const editMobileNumberModalStyles = ({ theme }) => ({
  paperClasses: {
    width: 400,
  },
  spinner: {
    height: theme.spacing(1) * 3,
  },
});

export default editMobileNumberModalStyles;
